module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/estadao-7063eb8dd20fdcbf778c6fa4bbacc639.png";